import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import Cta from "../common/ui/Cta";
import Input from "../common/components/Input";
import Paragraph from "../common/ui/Paragraph";
import Heading from "../common/ui/Heading";
import BlueTag from "../common/ui/BlueTag";

const ContactForm = () => {
  const formData = {
    firstName: "",
    lastName: "",
    email: "",
    number: "",
    message: "",
  };

  const [value, setValue] = useState(formData);
  const [error, setError] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [success, setSuccess] = useState(false);

  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(true);

    const isValid =
      value.firstName &&
      value.lastName &&
      value.email &&
      value.number &&
      emailRegex.test(value.email) &&
      value.number.length >= 10;

    if (!isValid) return;

    setIsSending(true);

    emailjs

      .send(
        "service_40gwxsi", // Replace with your EmailJS service ID
        "template_6tvvlkp", // Replace with your EmailJS template ID
        value,
        "dEsW42iLGgJ_LHF5d" // Replace with your EmailJS public key
      )

      .then(
        () => {
          setValue(formData);
          setError(false);
          setIsSending(false);
          setSuccess(true);
          setTimeout(() => {
            setSuccess(false);
          }, 2000);
        },
        (err) => {
          console.error("Error sending email:", err);
          setIsSending(false);
        }
      );
  };

  return (
    <div className="w-full 2xl:w-6/12 max-2xl:max-w-[580px] max-xl:max-w-[680px]">
      <div className="pb-10">
        <BlueTag>Contact Us</BlueTag>
        <Heading className="max-lg:max-w-[550px] pt-1">
          Let's Innovate Together
        </Heading>
        <Paragraph className="mt-3">
          These align with the themes of innovation, excellence, and
          collaboration present in the design. Let me know if you’d like a
          different style!
        </Paragraph>
      </div>
      <form
        onSubmit={handleSubmit}
        className="flex flex-col gap-6 w-full max-md:gap-4 max-md:px-0"
      >
        <div className="w-full flex items-center xl:justify-between max-xl:gap-5 max-md:gap-4 max-md:flex-col 2xl:gap-x-6">
          <div className="w-full max-2xl:max-w-[279px] max-xl:max-w-full flex flex-col gap-2">
            <Input
              htmlFor="first-name"
              id="first-name"
              label="First Name"
              type="text"
              onChange={(e) =>
                setValue({ ...value, firstName: e.target.value })
              }
              value={value.firstName}
            />
            {error && !value.firstName && (
              <p className="text-red-500">Please enter your first name</p>
            )}
          </div>
          <div className="w-full max-2xl:max-w-[279px] max-xl:max-w-full flex flex-col gap-2">
            <Input
              htmlFor="last-name"
              id="last-name"
              label="Last Name"
              type="text"
              onChange={(e) => setValue({ ...value, lastName: e.target.value })}
              value={value.lastName}
            />
            {error && !value.lastName && (
              <p className="text-red-500">Please enter your last name</p>
            )}
          </div>
        </div>
        <div className="w-full flex items-center justify-between max-xl:gap-5 max-md:gap-4 max-md:flex-col 2xl:gap-x-6">
          <div className="w-full max-2xl:max-w-[279px] max-xl:max-w-full flex flex-col gap-2">
            <Input
              htmlFor="email"
              id="email"
              label="Email"
              type="email"
              onChange={(e) => setValue({ ...value, email: e.target.value })}
              value={value.email}
            />
            {error && (!value.email || !emailRegex.test(value.email)) && (
              <p className="text-red-500">
                {value.email.length === 0
                  ? "Please enter your email"
                  : "Please enter valid email address"}
              </p>
            )}
          </div>
          <div className="w-full max-2xl:max-w-[279px] max-xl:max-w-full flex flex-col gap-2">
            <Input
              htmlFor="number"
              id="number"
              label="Phone Number"
              type="number"
              onChange={(e) => setValue({ ...value, number: e.target.value })}
              value={value.number}
            />
            {error &&
              (value.number.length === 0 ? (
                <p className="text-red-500">Please enter your number</p>
              ) : value.number.length < 10 ? (
                <p className="text-red-500">Please enter valid phone number</p>
              ) : null)}
          </div>
        </div>
        <div>
          <label
            htmlFor="message"
            className="cursor-pointer pl-0.5 text-custom-black leading-100 pb-2 inline-block"
          >
            Message
          </label>
          <textarea
            id="message"
            rows="6"
            value={value.message}
            onChange={(e) => setValue({ ...value, message: e.target.value })}
            className="bg-white outline-none h-full max-h-[179px] border-[1.5px] border-mix-white rounded-lg w-full text-base font-normal p-4 focus:border-custom-dark-blue resize-none"
          />
        </div>
        <Cta type="submit" className="mx-auto mt-4 w-full">
          {isSending ? "Sending..." : "Submit"}
        </Cta>
        {success && (
          <p className="text-green-600 text-center pt-2">
            ✅ Message sent successfully!
          </p>
        )}
      </form>
    </div>
  );
};

export default ContactForm;
